module.exports = __webpack_public_path__ + "static/img/PA.b70dc3b7.png";